import ApplicationController from './application_controller.js'
import TomSelect from 'tom-select/dist/esm/tom-select.complete'
export default class extends ApplicationController {
  static targets = ['sidebar', 'priceArea', 'powerPlants']

  connect() {
    // Initialize sidebar state
    this.selectPowerPlants = new TomSelect(this.powerPlantsTarget, {
      plugins: {
        remove_button: {
          title: 'Fjern valget'
        },
        clear_button: {
          title: 'Fjern alle valg'
        },
        checkbox_options: {
          className: 'rounded-sm'
        }
      }
    })

    this.originalPowerPlantsOptions = Array.from(
      this.selectPowerPlants.input.children
    )
  }

  toggleSidebar() {
    if (this.isOpen && !this.previousPortfolioId) {
      this.closeSidebar()
    } else {
      if (this.previousPortfolioId) {
        this.stimulate('SidebarForm#reset_form')
      }
      this.previousPortfolioId = null
      this.openSidebar()
    }
  }

  loadEditForm(event) {
    if (
      this.isOpen &&
      this.previousPortfolioId !== event.currentTarget.dataset.portfolioId
    ) {
      this.stimulate(
        'SidebarForm#load_form',
        event.currentTarget.dataset.portfolioId
      )
      this.previousPortfolioId = event.currentTarget.dataset.portfolioId
    } else if (this.isOpen) {
      this.closeSidebar()
    } else {
      const portfolioId = event.currentTarget.dataset.portfolioId
      this.previousPortfolioId = portfolioId
      this.stimulate('SidebarForm#load_form', portfolioId)
      this.openSidebar()
    }
  }

  afterReflex(element, reflex, noop, reflexId) {
    if (reflex === 'SidebarForm#load_form') {
      this.priceAreaTarget.disabled = true
    }
    this.selectPowerPlants = new TomSelect(this.powerPlantsTarget, {
      plugins: {
        remove_button: {
          title: 'Fjern valget'
        },
        clear_button: {
          title: 'Fjern alle valg'
        },
        checkbox_options: {
          className: 'rounded-sm'
        }
      }
    })
  }

  onPriceAreaChange() {
    const selectedPriceArea = this.priceAreaTarget.value
    const filteredOptions = this.originalPowerPlantsOptions.filter((option) => {
      return option.dataset.priceArea === selectedPriceArea
    })

    if (
      this.selectPowerPlants &&
      this.selectPowerPlants.addOption &&
      Array.isArray(filteredOptions)
    ) {
      this.selectPowerPlants.clearOptions()
      this.selectPowerPlants.addOption(filteredOptions)
    }

    if (selectedPriceArea) {
      this.selectPowerPlants.enable()
    } else {
      this.selectPowerPlants.disable()
    }
  }

  get isOpen() {
    return !this.sidebarTarget.classList.contains('hidden')
  }

  closeSidebar() {
    this.sidebarTarget.classList.add('hidden')
  }

  openSidebar() {
    this.sidebarTarget.classList.remove('hidden')
  }
}
